import React, { Component } from 'react';
import _ from 'underscore';

export default class extends Component {
    render() {
        let props = _.extend({
            className: 'link',
            target: '_blank'
        }, this.props);

        if (props.file_name) {
            props.href += '?download/' + props.file_name;
            delete props.file_name;
        }

        return (
            <a {...props}>下载</a>
        )
    }
}


// WEBPACK FOOTER //
// ./src/ui/uploader/download.js